import "../styles/KpiStrip.css";

/**
 * Bordered horizontal KPI strip (parchment palette, JetBrains Mono numerals).
 *
 * Styling cloned from `dfv2-kpis` in DefectsViewV2.css, decoupled from any
 * feature-scope CSS vars so the component renders consistently anywhere.
 *
 * Props:
 *   items: Array<{
 *     key:      string,                           // required, used as React key
 *     label:    string,                           // small uppercase label above value
 *     value:    string | number | ReactNode,      // primary value
 *     unit:     string,                           // optional small unit suffix on the value
 *     tone:     "default" | "red" | "amber" | "green",  // colour of the value
 *     sub:      string | ReactNode,               // small caption under the value
 *     onClick:  () => void,                       // optional, makes the tile clickable
 *     active:   boolean,                          // highlights when true (for tab-like usage)
 *   }>
 *   columns: number                               // optional grid template override
 */
export default function KpiStrip({ items = [], columns }) {
  if (!items.length) return null;
  const style = columns ? { gridTemplateColumns: `repeat(${columns}, 1fr)` } : undefined;
  return (
    <div className="kpi-strip" style={style}>
      {items.map((it) => {
        const Tag = it.onClick ? "button" : "div";
        const classes = [
          "kpi-strip__item",
          it.onClick ? "kpi-strip__item--clickable" : "",
          it.active ? "kpi-strip__item--active" : "",
        ].filter(Boolean).join(" ");
        return (
          <Tag
            key={it.key}
            type={it.onClick ? "button" : undefined}
            className={classes}
            onClick={it.onClick}
          >
            <span className="kpi-strip__lbl">{it.label}</span>
            <span className={`kpi-strip__val kpi-strip__val--${it.tone || "default"}`}>
              {it.value}
              {it.unit != null && it.unit !== "" && (
                <span className="kpi-strip__unit">{it.unit}</span>
              )}
            </span>
            {it.sub != null && it.sub !== "" && (
              <span className="kpi-strip__sub">{it.sub}</span>
            )}
          </Tag>
        );
      })}
    </div>
  );
}
